import styled from '@emotion/styled';
import Typography from '../Typography';

export const Container = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  &:hover {
    opacity: 0.5;
  }
  cursor: pointer;
`;

export const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
`;

export const InnerCircle = styled.span<{
  size: number;
  colorInner?: string;
}>`
  border-radius: 50%;
  position: absolute;
  height: ${({ size }) => `${size * 0.25}px`};
  width: ${({ size }) => `${size * 0.25}px`};
  background-color: ${({ colorInner, theme }) => {
    if (colorInner) return colorInner;
    return theme.brand.primary;
  }};
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const CustomRadio = styled.span<{
  size: number;
  checked: boolean;
  color: string;
  disabled?: boolean;
  uncheckColor?: string;
}>`
  border-radius: 50%;
  position: relative;
  height: ${({ size }) => `${size}px`};
  width: ${({ size }) => `${size}px`};
  border: ${({ checked, theme }) => {
    if (checked) return `1px solid transparent`;

    return `1px solid ${theme.brand.primary}`;
  }};
  background-color: ${({ checked, color, disabled, theme, uncheckColor }) => {
    if (checked) return color;
    if (disabled) return `${theme.grey.shade4}`;
    if (uncheckColor) return uncheckColor;

    return 'transparent';
  }};
`;

export const Label = styled(Typography)`
  margin-left: 8px;
  margin-right: 8px;
  color: ${({ theme }) => {
    return theme.brand.primary;
  }};
`;
